import { graphql } from 'gatsby';

import { styled } from '@mui/material';

import { TextWithClaim } from '@mewa/ui';

import { ComponentProps, PossibleContentSections } from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';

export const ClaimTextFragment = graphql`
  fragment ClaimTextFragment on STRAPI__COMPONENT_SHARED_CLAIM_TEXT {
    claim
    text
    strapi_component
  }
`;

export const componentName = 'shared.claim-text';

export type ClaimTextData = {
  claim: string;
  text: string;
  strapi_component: typeof componentName;
};

export const isClaimText = (
  component: PossibleContentSections,
): component is ClaimTextData => {
  return component.strapi_component === componentName;
};

export const StrapiTextWithClaim = (data: ComponentProps<ClaimTextData>) => (
  <StyledTextWithClaim
    claim={data.claim}
    introText={data.text}
    showTopDivider={data.componentIndex > 0}
  />
);

export const StyledTextWithClaim = styled(TextWithClaim)(({ theme }) => ({
  marginTop: '140px',
  marginBottom: '140px',

  [theme.breakpoints.down('sm')]: {
    marginTop: '58px',
    marginBottom: '58px',
  },
}));

export const config = {
  isComponent: isClaimText,
  Component: StrapiTextWithClaim,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  componentName,
  populationParams: {},
  mapProperties: (claimText): ClaimTextData | null =>
    claimText.strapi_component === componentName ? claimText : null,
};
